"use strict";
function cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = cacheHas;
